import { isBrowser } from './is-browser';
/**
 * Проверяет наличие разметки в кеше
 * @param name
 */
export function hasWidgetsMarkup(name) {
    var _a;
    return isBrowser() && !!((_a = window.widgets_markup) === null || _a === void 0 ? void 0 : _a[name]);
}
/**
 * Получает разметку из кеша
 * @param name
 */
export function getWidgetsMarkup(name) {
    var _a;
    return isBrowser() ? (_a = window.widgets_markup) === null || _a === void 0 ? void 0 : _a[name] : '';
}
/**
 * Добавляет разметку в кеш
 * @param name
 * @param markup
 */
export function setWidgetsMarkup(name, markup) {
    if (isBrowser()) {
        if (!window.widgets_markup) {
            window.widgets_markup = {};
        }
        window.widgets_markup[name] = markup;
    }
}
/**
 * Удаляет разметку из кеша
 * @param name
 */
export function removeWidgetsMarkup(name) {
    if (isBrowser() && (window === null || window === void 0 ? void 0 : window.widgets_markup)) {
        window === null || window === void 0 ? true : delete window.widgets_markup[name];
    }
}
